import { useCallback, useEffect, useRef, useState } from 'react'

import { useRemoteCollection } from 'civic-champs-shared/api/hooks'
import { useGetRegistrants } from './useGetRegistrants'

const useRegistrants = query => {
  const { date, personId } = query
  const [getRegistrants, { loading, error }] = useGetRegistrants()
  const [registrants, operations] = useRemoteCollection()
  const [initiallyLoaded, setInitiallyLoaded] = useState(false)

  const currRequestIdRef = useRef(0)

  const { syncCollection } = operations
  const reload = useCallback(async () => {
    const requestId = (currRequestIdRef.current += 1)
    const updatedRegistrants = await getRegistrants({
      date,
      personId,
      includeVolunteerTags: true,
    })

    if (requestId === currRequestIdRef.current) {
      syncCollection(updatedRegistrants)
      setInitiallyLoaded(true)
    }
  }, [getRegistrants, date, personId, syncCollection])

  useEffect(() => {
    reload()
  }, [reload])

  return [
    {
      registrants,
      loading,
      error,
      initiallyLoaded,
      reload,
    },
    operations,
  ]
}

export default useRegistrants
